import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-conditions-utilisation-pes',
    templateUrl: './conditions-utilisation-pes.component.html',
    styleUrls: ['./conditions-utilisation-pes.component.scss'],
    imports: [
        TranslateModule
    ]
})
export class ConditionsUtilisationPesComponent {
}
